export const SettingsTemplate = `
{{{changeAvatar}}}
{{{userSettings}}}
{{{changePassword}}}
`;
